<template>
  <div class="test_container">
    <div class="tab_wrap">
      <div class="change-child" v-if="userType == 'PARENT'">
        <span class="name-drp">当前儿童：</span>
        <div class="name-warp" @click="showAllChild">
          <span class="name">
            {{
              (children.find((item) => item.id == selectId) || {}).studentName
            }}
          </span>
          <img
            src="../../assets/images/parent-course/rigth-arrow-big.png"
            class="right-arrow"
            alt="向右展开箭头"
          />
        </div>
      </div>
      <ul class="change-tab">
        <router-link :to="{ path: '/course' }">
          <li class="health-education">
            <span>迪夫学院</span>
          </li>
        </router-link>
        <router-link :to="{ path: '/testCenter' }">
          <li class="assess-active">
            <span>筛查及考核</span>
          </li>
        </router-link>
      </ul>
    </div>
    <!-- <present-children :showTitle="false" :showChildren="true" :children="children" @select="select($event)" :value="value" /> -->
    <div class="content">
      <div class="mainBg">
        <div
          class="parents"
          @click="toTest(1)"
          v-if="assessName === '自助测试'"
        >
          <!-- <div class="dot" v-if="parentNum"><span>{{parentNum}}</span></div> -->
          <span class="name">自助测试</span>
          <img
            class="right-arrow"
            src="../index/images/right-arrow.png"
            alt="朝右箭头"
          />
        </div>
        <div class="kid" @click="toTest(2)" v-else>
          <!-- <div class="dot" v-if="currentChildNum"><span>{{currentChildNum}}</span></div> -->
          <span class="name">儿童功能自测量表</span>
          <img
            class="right-arrow"
            src="../index/images/right-arrow.png"
            alt="朝右箭头"
          />
        </div>
        <div class="course-test" @click="toTest(3)">
          <span class="name">课程考核</span>
          <img
            class="right-arrow"
            src="../index/images/right-arrow.png"
            alt="朝右箭头"
          />
        </div>
      </div>
    </div>
    <dialog-one
      :infoShow="infoShow"
      :infoMsg="infoMsg"
      @next="next"
      @goback="close"
    ></dialog-one>
    <van-overlay
      :show="showAllChildOverlay"
      z-index="5"
      @click="showAllChildOverlay = false"
    >
      <div class="namelist-warp" @click.stop>
        <div>请选择当前儿童</div>
        <div
          class="namelist-item"
          :class="{ 'namelist-item-active': index == selectIndex }"
          v-for="(item, index) in children"
          :key="item.id"
          @click="selectIndex = index"
        >
          {{ item.studentName }}
        </div>
        <van-button
          color="rgba(14, 215, 225, 0.20)"
          text="确定"
          round
          @click="sureChild"
        ></van-button>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { decryptBy } from "@/assets/js/encryption";
import { verticalScreen } from "../../assets/js/vertical-screen";
import dialogOne from "./../../components/dialog/index.vue";
import presentChildren from "../../components/present-children/index";
import {
  _checkStudentPrivacyEnable,
  _paperNum,
} from "../../api/test-center.js";
import { Toast } from "vant";
export default {
  name: "test-center",
  components: { dialogOne, presentChildren },
  props: {},
  data() {
    return {
      assessName: "",
      showAllChildOverlay: false,
      selectIndex: 0,
      // tepChildSelect: sessionStorage.getItem('childCurrentId'),
      parentsImg: require("../../assets/images/test-center/parents.png"),
      kidImg: require("../../assets/images/test-center/kid.png"),
      ifHasPassword: true, //是否设置过家长密码
      ifHasChildPassword: true, //是否设置过儿童密码
      infoShow: false, //弹窗显示标识
      infoMsg: "您还没设置(家长/儿童)隐私密码，快来设置吧。", //弹窗文本
      nameFlag: "", //区分家长孩子
      checked: "", //隐私密码设置状态
      value: "",
      parentsRelation: "", //家长信息相关
      paramsPaperNum: {
        childId: "",
        parentId: "",
        useObject: "",
      },
      totalNum: 0,
      currentChildNum: 0, //当前儿童的进行中的问卷数量
      childAllNum: 0, //当前所有儿童的进行中的问卷数量
      parentNum: 0, //家长的进行中的问券数量
      paramsCategory: {
        childId: "",
        parentId: "",
        projectKey: "",
        resourceFrom: "",
      },
      userType: "",
    };
  },
  watch: {},
  methods: {
    showAllChild() {
      this.showAllChildOverlay = true;
      this.selectIndex = this.children.findIndex(
        (item) => item.id == this.selectId
      );
    },
    sureChild() {
      this.$store.commit("CHILDID", this.children[this.selectIndex].id);
      this.$emit("selectChild", this.selectId);
      this.showAllChildOverlay = false;
    },

    //点击家长儿童
    toTest(val) {
      this.nameFlag = val;
      this.checkPrivacyEnable(val);
    },
    //查看家长隐私密码设置状态
    checkPrivacyEnable(val) {
      this.$router.push({
        path: "/testType",
        query: {
          type: val,
        },
      });
    },
    // 查询儿童家长进行中的问卷数量
    async paperNum(paramsPaperNum) {
      try {
        let res = await _paperNum(paramsPaperNum);
        let { code, data, message } = res;
        if (res && code === 200) {
          this.parentNum = data.parentCount;
          this.childAllNum = data.childTotal;
          this.currentChildNum = data.childCount;
          this.totalNum = data.parentCount + data.childTotal;
        } else {
          Toast(message);
        }
      } catch (error) {
        console.error(error);
      }
    },

    //弹窗点击确定
    next() {
      this.$router.push({
        path: "/privacyPassword",
        query: {
          status: this.nameFlag,
        },
      });
      this.infoShow = false;
    },
    // 判断儿童、学生
    getObject(id) {
      let children =
        localStorage.getItem("children") &&
        JSON.parse(decryptBy(localStorage.getItem("children")));
      if (children && children.length > 0) {
        let child = children.filter((item) => {
          return item.id == id;
        });
        if (child[0].serviceStatus === 1) {
          this.paramsPaperNum.useObject = 2;
        } else {
          this.paramsPaperNum.useObject = 1;
        }
      }
    },
    // 选择当前儿童
    select(value) {
      // 当我切换儿童的时候，将儿童对应的id发请求获取当前儿童的在进行中的问券的数量
      this.paramsPaperNum.childId = value;
      this.paperNum(this.paramsPaperNum);
      this.value = value;
      localStorage.setItem("childId", this.value);
      this.getObject(value);
    },
    //关闭弹窗
    close() {
      this.infoShow = false;
    },
  },
  computed: {
    allNum() {
      return this.childAllNum + this.parentNum;
    },
    children() {
      return this.$store.state.children;
    },
    selectId() {
      return this.$store.state.childId;
    },
  },
  created() {
    try {
      if (decryptBy(localStorage.getItem("userInfo"))) {
        this.parentsRelation = JSON.parse(
          decryptBy(localStorage.getItem("userInfo"))
        );
        if (this.parentsRelation && this.parentsRelation.userType == "PARENT") {
          this.assessName = "自助测试";
        } else {
          this.assessName = "儿童功能自测量表";
        }
        this.userType = this.parentsRelation.userType;
      }
      this.paramsPaperNum.parentId = this.parentsRelation.id;
      // 清楚养育课的session part1
      sessionStorage.removeItem("tabChangeMain");
      sessionStorage.removeItem("tabInfoDetail");
      sessionStorage.removeItem("tabValue");
      if (localStorage.getItem("childId")) {
        this.value = localStorage.getItem("childId");
        // 代表我已经点击了select了，那么我返回页面，依然要读取我当前点击的select
        this.paramsPaperNum.childId = this.value;
        this.paperNum(this.paramsPaperNum);
      } else {
        if (this.children.length > 0) {
          this.paramsPaperNum.childId = this.children[0].id;
        }

        this.paperNum(this.paramsPaperNum);
      }
      this.getObject(this.paramsPaperNum.childId);
    } catch (error) {
      console.error(error);
    }
  },
  beforeMount() {},
  mounted() {
    verticalScreen();
  },
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style lang="scss" scoped>
$tabCenter: "../../assets/images/parent-course/tab-center.png";
$tabCommon: "../../assets/images/parent-course/tab-common.png";
.test_container {
  .tab_wrap {
    padding: 12px 20px 8px 20px;
    .change-child {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 500;
      .name-drp {
        color: #333333;
      }
      .name-warp {
        display: flex;
        align-items: center;
        .name {
          color: #00aadf;
          line-height: 22px;
        }
        .right-arrow {
          width: 22px;
          height: 22px;
        }
      }
    }
  }
  .change-tab {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 500;
    .health-education {
      width: 146px;
      height: 70px;
      background: url(('../index/images/health-education.png')) no-repeat;
      background-size: 100% 100%;
      box-shadow: 0px 4px 12px 0px rgba(24, 190, 184, 0.2);
      font-size: 14px;

      line-height: 70px;
      padding-left: 20px;
      span {
        color: #333333;
      }
    }
    .health-education-active {
      width: 172px;
      height: 82px;
      background: url("../index/images/health-education-active.png") no-repeat;
      background-size: 100% 100%;
      box-shadow: 0px 4px 12px 0px rgba(24, 190, 184, 0.2);
      font-size: 16px;

      line-height: 82px;
      padding-left: 20px;
      span {
        color: #ffffff;
      }
    }
    .assess {
      width: 146px;
      height: 70px;
      background: url("../index/images/assess.png") no-repeat;
      background-size: 100% 100%;
      box-shadow: 0px 4px 12px 0px rgba(24, 190, 184, 0.2);
      font-size: 14px;
      line-height: 70px;
      padding-left: 20px;
      span {
        color: #333333;
      }
    }
    .assess-active {
      width: 176px;
      height: 82px;
      background: url("../index/images/assess-active.png") no-repeat;
      box-shadow: 0px 4px 12px 0px rgba(24, 190, 184, 0.2);

      background-size: 100% 100%;
      font-size: 16px;
      line-height: 82px;
      padding-left: 20px;

      span {
        color: #ffffff;
      }
    }
  }

  .content {
    padding: 12px 20px 0;
    .mainBg {
      .name {
        color: #2e4344;
        font-size: 18px;
      }
      .right-arrow {
        margin-left: 12px;
        width: 22px;
        height: 22px;
      }
      .parents {
        display: flex;
        align-items: center;
        width: 335px;
        height: 120px;
        background: url("../index/images/parent-test-bg.png") no-repeat;
        background-size: 100% 100%;
        padding-left: 26px;
        .dot {
          position: absolute;
          right: 0;
          top: 0;
          width: 25px;
          height: 25px;
          background-color: #ff5656;
          border-radius: 50%;
          transform: translate(8px, -8px);
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            color: #ffffff;
          }
        }
        p {
          font-size: 18px;
          color: #ff8340;
          line-height: 25px;
        }
      }
      .course-test {
        display: flex;
        align-items: center;
        width: 335px;
        height: 120px;
        background: url("../index/images/course-test-bg.png") no-repeat;
        background-size: 100% 100%;
        padding-left: 26px;
        margin-top: 8px;
        .dot {
          position: absolute;
          right: 0;
          top: 0;
          width: 25px;
          height: 25px;
          background-color: #ff5656;
          border-radius: 50%;
          transform: translate(8px, -8px);
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            color: #ffffff;
          }
        }
        p {
          font-size: 18px;
          color: #ff8340;
          line-height: 25px;
        }
      }
      .kid {
        display: flex;
        align-items: center;
        width: 335px;
        height: 120px;
        background: url("../index/images/therapist-test-bg.png") no-repeat;
        background-size: 100% 100%;
        padding-left: 26px;
        .dot {
          position: absolute;
          right: 0;
          top: 0;
          width: 25px;
          height: 25px;
          background-color: #ff5656;
          border-radius: 50%;
          transform: translate(8px, -8px);
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            color: #ffffff;
          }
        }
        p {
          font-size: 18px;
          color: #ff8340;
          line-height: 25px;
        }
      }
    }
  }
}
::v-deep .el-select-dropdown.el-popper {
  left: 9px !important;
}
.namelist-warp {
  margin: 85px auto 0 auto;
  width: 220px;
  padding: 16px 20px;
  background-color: #fff;

  border-radius: 0px 12px 12px 12px;
  font-size: 16px;

  font-weight: 500;
  text-align: center;
  .namelist-item {
    margin-top: 25px;
    color: #626a6b;
    &:nth-of-type(1) {
      margin-top: 22px;
    }
  }
  .namelist-item-active {
    color: #00aadf;
  }
  .van-button {
    margin-top: 20px;
    width: 100%;
    height: 40px;
    color: #0ed7e1 !important;
    font-size: 16px;
    border: none;
  }
}
.van-overlay {
  background: rgba(0, 0, 0, 0.4);
}
</style>
